import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Start Date', prop: 'start_date', format: 'dateWithDay' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'start_date', direction: 'desc' }]
}

const Curriculums = props => (
  <List
    title='Curriculums'
    apiPath='admin/curriculums'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default Curriculums
